import { Box, Container, Typography, IconButton } from "@mui/material";

const Footer = () => {
  return (
    <>
      <Container
        maxWidth="xxl"
        sx={{
          px: { xs: 0, md: -2, lg: 0 },
          mb: -2,
          py: { xs: 0, md: -2, lg: 0 },
          overflowX: "hidden",
        }}
      >
        <Box
          component="img"
          src="/assets/wave.svg"
          alt="Wave"
          sx={{
            width: "100%",
            display: "block",
            position: "relative",
          }}
        />
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#FFF9F0",
            py: 0,
            px: 0,
            m: 0,
            position: "relative",
            overflowX: "hidden",
          }}
        >
          <Container maxWidth="xl" sx={{ px: { xs: 1, md: 4 } }}>
            {/* Main Column Container */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 4, md: 4 },
                pt: { xs: 1, md: 0 },
                pb: { xs: 0, md: 0 },
                px: { xs: 0, md: 0 },
              }}
            >
              {/* First Row - Logo and Text */}
              <Box
                sx={{
                  display: "flex",
                  height: { xs: "auto", md: "180px" },
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "center", md: "top" },
                  gap: { xs: 2, md: 2 },
                  mt: { xs: -4, md: 10 },
                  px: { xs: 2, md: 0 },
                }}
              >
                {/* Logo */}
                <Box
                  component="img"
                  src="/assets/logolatest.svg"
                  alt="Yuva Changemakers Logo"
                  sx={{
                    width: { xs: "290px", sm: "550px", md: "550px" },
                    maxWidth: { xs: "290px", sm: "550px", md: "650px" },
                    height: { xs: "auto", md: "auto" },
                    mt: { xs: 6, md: -6 },
                    mb: { xs: 3, md: 0 },
                  }}
                />

                {/* Text and CTA Container */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: { xs: "flex-end", md: "flex-end" },
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: { xs: 2, md: 4 },
                    mt: { xs: 0, md: 14 },
                    pr: { xs: 0, md: 4 },
                  }}
                >
                  {/* Paragraph Text */}
                  <Typography
                    sx={{
                      fontFamily: '"Test Domaine Display", serif',
                      fontWeight: { xs: 400, md: 500 },
                      fontSize: { xs: "24px", md: "26px" },
                      color: "#000",
                      lineHeight: { xs: "35.39px", md: "50px" },
                      letterSpacing: "0px",
                      textAlign: "right",
                      mt: { xs: -2, md: -3 },
                      maxWidth: { xs: "100%", md: "550px" },
                    }}
                  >
                    Yuva Changemakers is a 1-year leadership fellowship
                    programme for the youth of Himachal Pradesh, who want to go
                    beyond talking about change and actively create it.
                  </Typography>

                  {/* CTA Button */}
                  <Box
                    component="a"
                    href="tel:+918988000777"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontFamily: "Elza, sans-serif",
                      gap: "10px",
                      width: { xs: "160px", md: "190.96px" },
                      height: { xs: "20px", md: "32px" },
                      borderRadius: "40px",
                      paddingTop: "8px",
                      paddingRight: "16px",
                      fontSize: { xs: "16px", md: "16px" },
                      paddingBottom: "8px",
                      paddingLeft: "14px",
                      backgroundColor: "#000",
                      color: "#fff",
                      textDecoration: "none",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#333333",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src="/assets/phone.png"
                      alt="Phone"
                      sx={{
                        width: "15px",
                        height: "15px",
                        objectFit: "contain",
                      }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Elza, sans-serif",
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 500,
                        color: "#fff",
                        whiteSpace: "nowrap",
                      }}
                    >
                      CALL US - 89880 00777
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Second Row - Cutout Image and Social Icons */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  gap: 2,
                  px: { xs: 2, md: 10 },
                }}
              >
                {/* Cutout Image */}
                <Box
                  component="img"
                  src="/assets/footercutout.png"
                  alt="Youth Leaders"
                  sx={{
                    width: { xs: "200px", sm: "280px", md: "380px" },
                    height: "auto",
                    objectFit: "contain",
                    alignSelf: "flex-end",

                    ml: { xs: -2, md: 0 },
                  }}
                />

                {/* Social Icons Container */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: { xs: 2, md: 1.5 },
                    alignItems: { xs: "flex-end", md: "center" },
                    mb: { xs: 9, md: 14 },
                    mr: { xs: 3, md: 8, lg: 14 },
                    pr: { xs: 1 },
                  }}
                >
                  {/* First Row - Snapchat, LinkedIn, Twitter */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: { xs: 2, md: 1.5 },
                    }}
                  >
                    <IconButton
                      component="a"
                      href="https://www.snapchat.com/add/yuvachangemakers"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Visit our Snapchat"
                      sx={{
                        color: "#000",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/socialone.png"
                        alt="Snapchat"
                        sx={{
                          width: "37px",
                          height: "37px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      component="a"
                      href="https://www.linkedin.com/company/yuvachangemakers"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Visit our LinkedIn page"
                      sx={{
                        color: "#000",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/socialtwo.png"
                        alt="LinkedIn"
                        sx={{
                          width: "37px",
                          height: "37px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      component="a"
                      href="https://x.com/yuvachangemaker/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Visit our Twitter page"
                      sx={{
                        color: "#000",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/socialthree.png"
                        alt="Twitter"
                        sx={{
                          width: "37px",
                          height: "37px",
                        }}
                      />
                    </IconButton>
                  </Box>

                  {/* Second Row - Facebook, Instagram */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: { xs: 2, md: 1.5 },
                    }}
                  >
                    <IconButton
                      component="a"
                      href="https://www.facebook.com/yuvachangemakers"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Visit our Facebook page"
                      sx={{
                        color: "#000",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/socialfour.png"
                        alt="Facebook"
                        sx={{
                          width: "37px",
                          height: "37px",
                        }}
                      />
                    </IconButton>
                    <IconButton
                      component="a"
                      href="https://www.instagram.com/yuvachangemakers/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Visit our Instagram page"
                      sx={{
                        color: "#000",
                        padding: 0,
                        "&:hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/socialfive.png"
                        alt="Instagram"
                        sx={{
                          width: "37px",
                          height: "37px",
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>
      </Container>
    </>
  );
};

export default Footer;
